<div mat-dialog-title class="mat-title" i18n>Export numbers</div>
<form #form="ngForm" novalidate (ngSubmit)="save()">
    <!-- #region Destination provider -->
    <div layout="row" flex>
        <mat-form-field flex>
            <mat-label i18n>Destination provider</mat-label>
            <vd-select [(ngModel)]="data.destinationCarrierId" endpoint="carrier?enabled=true" name="destinationCarrierId" key="code" #destinationCarrierId="ngModel" placeholder="Destination provider" required i18n-placeholder flex></vd-select>
            <mat-error *ngIf="destinationCarrierId.errors?.required"><span i18n>Destination provider</span><span i18n> is required</span></mat-error>
        </mat-form-field>
    </div>
    <!-- #endregion -->

    <!-- #region Numbers to export -->
    <div class="mat-submat-subheading-2 push-bottom-none pad-top" i18n>Phone numbers</div>
    <mat-selection-list #selectedPhoneNumbers class="pad-bottom">
        <mat-list-option *ngFor="let assignedNumber of data.phoneNumbers" selected disabled [value]="assignedNumber.id">
            ({{assignedNumber.phoneNumber?.nationalDestinationCode}}){{assignedNumber.phoneNumber?.subscriberNumber}}
        </mat-list-option>
    </mat-selection-list>
    <!-- #endregion -->

    <div mat-dialog-actions class="pad-top">
        <button type="submit" mat-flat-button color="primary" [disabled]="!data.destinationCarrierId || !data.phoneNumbers?.length" color="primary" i18n>Save</button>
        <button type="button" mat-button (click)="cancel()" i18n>Cancel</button>
    </div>
</form>